/**
 * Compile Final Debt Inventory — subsection 5 (/sframe-199-s5)
 */

import { useParams } from 'react-router-dom';
import DebtReviewSectionShell, { type ChecklistItemDef } from './DebtReviewSectionShell';

const ITEMS: ChecklistItemDef[] = [
  {
    id: 'compile-1',
    title: 'Reconcile Balances',
    description: 'Cross-check worksheet totals against creditor statements.',
  },
  {
    id: 'compile-2',
    title: 'Generate Debt Summary',
    description: 'Create a single list with all validated debts, amounts, and priorities.',
  },
  {
    id: 'compile-3',
    title: 'Review with Legal Counsel',
    description: 'Have estate attorney confirm the final inventory before payment.',
  },
];

export default function ReviewOrganize_CompileInventory() {
  const { estateId } = useParams<{ estateId: string }>();

  return (
    <DebtReviewSectionShell
      estateId={estateId}
      title="Compile Final Debt Inventory"
      sectionIndex={5}
      checklistFrameId="sframe-199-s5"
      hubSectionKey="s5"
      items={ITEMS}
    />
  );
}
